import { metaKey } from '~/scripts/utils';
import { YOUTUBE } from '@/constants/youtube';

export default async ({ $api, app, redirect, route, store }) => {
  const slug = route.params.category;
  let category = null;
  await $api('media/videos/categories').then(categories => {
    if (slug) {
      const categoryById = categories.find(c => c.id === slug);
      if (categoryById) {
        return redirect(302, app.localePath(`/videos/${categoryById.title}/`));
      }
      category = categories.find(c => c.title === slug);
      if (category) {
        const breadcrumbs = [['i18n/home', '/'], ['i18n/videos', '/videos/'], category.description];
        route.meta[0] = { ...route.meta[0], ...{ breadcrumbs, jumbotronScope: 'videos.category', jumbotronParams: { category: category.description } } };
      } else {
        return redirect(302, app.localePath('/videos/'), { flashClass: 'error', flashMessage: store.$i18n.t('errors.videoCategoryNotFound') });
      }
    }
    store.commit('blog/setCategories', categories);
  });
  const playlist = category ? category.id : metaKey(route, 'playlist');
  await $api('media/videos', { playlist }).then(r => store.commit('blog/setList', r));
  await $api(`media/videos/${YOUTUBE.howToVideoId}`).then(r => store.commit('blog/setArticle', r));
};
